import idbStorage from "./IDB";

export async function save(key, value) {
    return await idbStorage.set(key, value);
}

export async function saveMergeObject(key, value, defaultValue = {}) {
    const old = (await load(key)) ?? defaultValue;
    return await save(key, {
        ...old,
        ...value,
    });
}

export async function load(key) {
    const loadedItem = await idbStorage.get(key);

    // if key doesn't exist
    if(loadedItem === null || typeof loadedItem === 'undefined') return null;

    return loadedItem;
}

export async function remove(key) {
    return await idbStorage.delete(key);
}

export async function clearStorage() {
    //webStorageClearStorage();
    return await idbStorage.purgeDatabase();
}
